module.exports = __webpack_public_path__ + "static/media/dhruv_saharan.a87f1da4.jpeg";